import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import PostStream from 'flarum/forum/components/PostStream';
import DiscussionOverview from './components/DiscussionOverview';


app.initializers.add('dvdfab/flarum-discussion-overview', () => {
 

  extend(PostStream.prototype, 'oncreate', function () {
    const postStream: HTMLElement | null = document.querySelector('.CommentPost div');

    if (!postStream) {
      return;
    }

    const discussion = this.discussion;
    
    // 确保 discussion 包含必要的关系数据
    if (!discussion.lastPost() || !discussion.lastPostedUser()) {
      // 如果关系数据不存在，尝试重新加载
      app.store.find('discussions', discussion.id(), {
        include: 'lastPost,lastPostedUser'
      }).then(() => {
        // 重新渲染组件
        m.redraw();
      });
    }

    const div = document.createElement('div');
    div.className = 'DiscussionOverview';

    m.mount(postStream.appendChild(div), {
      view: function () {
        return m(DiscussionOverview, { discussion });
      },
    });
  });
});
